function BuildColumns(screenElementList, TableScreenElements, columns) {
  if (screenElementList && columns.length == 0) {
    let elements = [];
    if (typeof TableScreenElements === "function") {
      elements = TableScreenElements();
    } else {
      elements = TableScreenElements;
    }
    elements.forEach(x => {
      if (x.isBaseColumn) {
        columns.push(x);
      } else {
        const found = screenElementList.find(
          pref => pref.screenElementId === x.id && pref.isSelected
        );
        if (found) {
          x.label = found.title;
          x.layoutOrder = found.layoutOrder;
          x.sort = found.sortOrder;
          columns.push(x);
        }
      }
    });
    columns.sort((a, b) => a.layoutOrder - b.layoutOrder);
  }
}

export default BuildColumns;
